import api from './global-variable.js'
import axios from 'axios'

export default async (url = '', option = {}) => {
  url = api.api_url + url
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      ...option
    }).then(function (res) {
      // console.info(res.request.responseURL, res.data)
      resolve(res.data)
    }).catch(function (res) {
      // console.error(res.response.status, res.request.responseURL, res.response)
      let msg = []
      for (let prop in res.response.data) {
        let _msg = res.response.data[prop]
        if (_msg instanceof Array) {
          msg.push(_msg[0])
        } else {
          msg.push(_msg)
        }
      }
      res.response['msg'] = msg.join(',')
      reject(res.response)
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js